import Marquee from "react-fast-marquee";
import { TRUST_BADGES } from "@/data/content";

export const TrustMarquee = () => (
  <section className="bg-brand-navy py-5 border-y border-white/5" data-testid="trust-marquee">
    <Marquee speed={38} gradient={false} autoFill pauseOnHover>
      {TRUST_BADGES.map((b, i) => (
        <span key={i} className="flex items-center">
          <span className="mx-8 font-display font-bold text-lg sm:text-xl tracking-[0.06em] text-white/90 whitespace-nowrap">
            {b}
          </span>
          <span className="h-2 w-2 rounded-full bg-brand-red" />
        </span>
      ))}
    </Marquee>
  </section>
);
